import { gql } from "@apollo/client";

export const GET_PDR_HISTORY_DETAILS_QUERY = gql`
  query GetPDRHistoryDetails($id: ID!, $pgaId: String!) {
    pdrHistoryDetails(id: $id, pgaId: $pgaId) {
      activityCode
      author
      category
      creditType
      creditsAccepted
      creditsAppliedFor
      description1
      description2
      id
      location
      submittedAt
      participationDates {
        startedOn
        endedOn
      }

      activityParticipation {
        id
        title
        canEdit
        canDelete
        isTypeLevelParticipation
        role
        attendanceType
        quantity
        activityType {
          id
          title
          description
          sectionAvailability
          createsEvent
          config {
            creditRates {
              id
              rateMultiplier
              rateUnit
              attendanceType
              participationRole
              legacyCreditType
            }
          }
        }
        activity {
          id
          title
          allowParticipationStarting
          allowParticipationThrough
          duration
          activityType {
            id
            title
            description
            sectionAvailability
            createsEvent
            config {
              creditRates {
                id
                rateMultiplier
                rateUnit
                attendanceType
                participationRole
                legacyCreditType
              }
            }
          }
          managingSection {
            id
          }
        }
      }
    }
  }
`;
